module.exports = __webpack_public_path__ + "static/elle-20eb485dba6c3fdd727a1c56eae33a11.png";